import { RootAction, MessageTemplate, Page } from "../types";

export interface State {
  data: {
    messageTemplateList: Page<MessageTemplate> | null;
  };
  loading: boolean;
}

const blankState = () => ({
  data: {
    messageTemplateList: null
  },
  loading: false
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case "messagePatient/getPatientLibrary-started":
      return {
        ...state,
        loading: true
      };
    case "messagePatient/getPatientLibrary-success":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          messageTemplateList: action.messageTemplateList
        }
      };
    case "messagePatient/getPatientLibrary-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "messagePatient/sendUnsecureMessage-started":
      return {
        ...state,
        loading: true
      };
    case "messagePatient/sendUnsecureMessage-success":
      return {
        ...state,
        loading: false,
        error: null
      };
    case "messagePatient/sendUnsecureMessage-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
    case "messagePatient/sendSecureMessage-started":
      return {
        ...state,
        loading: true
      };
    case "messagePatient/sendSecureMessage-success":
      return {
        ...state,
        loading: false,
        error: null
      };
    case "messagePatient/sendSecureMessage-failure":
      return {
        ...state,
        loading: false,
        errorMessage: action.errorMessage
      };
  }

  return state;
};
